import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import {
  AlertController,
  ModalController,
  Platform,
  ToastController,
} from "@ionic/angular";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { distinctUntilChanged, first } from "rxjs";
import { NewAddressModalComponent } from "src/app/address/new-address-modal/new-address-modal.component";
import { FirebaseRecaptchaLoginComponent } from "src/app/popups/firebase-recaptcha-login/firebase-recaptcha-login.component";
import { FirebaseRecaptchaComponent } from "src/app/popups/firebase-recaptcha/firebase-recaptcha.component";
import { MagicLoginConfirmationComponent } from "src/app/popups/magic-login-confirmation/magic-login-confirmation.component";
import { OrderNowPopupComponent } from "src/app/popups/order-now-popup/order-now-popup.component";
import { OrderNowSettingsPopupComponent } from "src/app/popups/order-now-popup/order-now-settings-popup/order-now-settings-popup.component";
import { currentStoreID, getStoreInfo } from "src/app/store/app.selectors";
import { VisitorSessionAssistService } from "../visitor-session-assist/visitor-session-assist.service";
import * as AuthActions from "../../auth/store/auth.actions";
import * as fromApp from "../../store/app.reducer";
import { AnalyticsServiceService } from "../analitycsService/analytics-service.service";
import * as DeliveryMethodAddressActions from "../../store/deliveryMethodAddress/deliveryMethodAddress.actions";
import * as CurrentStoreActions from "../../store/current-store/current-store.actions";
import * as _ from "lodash";
import { DineInModalComponent } from "src/app/popups/dine-in-modal/dine-in-modal.component";
import { Capacitor } from "@capacitor/core";
import { SelectStoreImagePopupComponent } from "src/app/popups/select-store-image-popup/select-store-image-popup.component";
import { DeliveryInfoModalComponent } from "src/app/popups/delivery-info-modal/delivery-info-modal.component";
import { SelectedFixedPointsAddressModalComponent } from "src/app/address/selected-fixed-points-address-modal/selected-fixed-points-address-modal.component";
import { fixedAddressesService } from "../fixedAddressesService/fixed-addresses.service";
import { v4 as uuid } from "uuid";
import { FixedPointsAddressConfirmationPopupComponent } from "src/app/address/selected-fixed-points-address-modal/fixed-points-address-confirmation-popup/fixed-points-address-confirmation-popup.component";
import { DineinValidationsService } from "../dineInValidations/dinein-validations.service";
import { SelectStorePopupComponent } from "src/app/popups/select-store-popup/select-store-popup.component";
import { NoScannerAvailableModalComponent } from "src/app/popups/order-now-popup/no-scanner-available-modal/no-scanner-available-modal.component";
import { DataStorageService } from "../data-storage/data-storage.service";
import { QrScanModalComponent } from "src/app/popups/order-now-popup/qr-scan-modal/qr-scan-modal.component";
import { App } from "@capacitor/app";
import { DineinTableLabelService } from "../dinein-table-label/dinein-table-label.service";
declare let window: any;
@Injectable({
  providedIn: "root",
})
export class OrderNowModalPopupsService {
  private settingsModal: any;
  private addNewAddressModal: any;
  private firebaseRecaptchaModal: any;
  private groupApp: any;
  private dineInModal: any;
  private deliveryInfoModal;
  private selectedLangugage;
  private baseLanguage;
  private carTakeAwayPlateNumber;
  private carTakeAwayComments;
  private selectedStore;
  private qrScanModal;
  private noQrScannerModal;
  constructor(
    private modalCtrl: ModalController,
    private alertController: AlertController,
    private translateService: TranslateService,
    private toastController: ToastController,
    private fixedAddressesService: fixedAddressesService,
    private dineInValidationsService: DineinValidationsService,
    private store: Store<fromApp.AppState>,
    private analyticsService: AnalyticsServiceService,
    private dataStorageService: DataStorageService,
    private router: Router,
    private platform: Platform,
    private visitorSessionAssistService: VisitorSessionAssistService,
    private dineinTableLabelService: DineinTableLabelService
  ) {
    console.log("service constructor called");
    this.groupAppSubscription();
    this.deliveryMethodAddressSubFc();
  }

  public deliveryMethodAddressSubFc() {
    this.store
      .select("deliveryMethodAddress")
      .pipe(distinctUntilChanged())
      .subscribe((state) => {
        if (
          state &&
          !_.isEqual(this.carTakeAwayPlateNumber, state.carTakeAwayPlateNumber)
        ) {
          this.carTakeAwayPlateNumber = _.cloneDeep(
            state.carTakeAwayPlateNumber
          );
        }

        if (
          state &&
          !_.isEqual(this.carTakeAwayComments, state.carTakeAwayComments)
        ) {
          this.carTakeAwayComments = _.cloneDeep(state.carTakeAwayComments);
        }
      });
  }

  public groupAppSubscription() {
    this.store
      .select("groupApp")
      .pipe(distinctUntilChanged())
      .subscribe((state) => {
        if (
          state &&
          state.groupApp &&
          !_.isEqual(this.groupApp, state.groupApp)
        ) {
          this.groupApp = _.cloneDeep(state.groupApp);

          const moBaseLanguage = _.find(this.groupApp.languages, {
            mo_base: true,
          });
          if (moBaseLanguage && moBaseLanguage.code) {
            this.baseLanguage = moBaseLanguage.code;
          }
        }
        if (
          state &&
          state.selectedLangugage &&
          !_.isEqual(this.selectedLangugage, state.selectedLangugage)
        ) {
          this.selectedLangugage = _.cloneDeep(state.selectedLangugage);
        }
      });
  }

  private async presentSettingsModal(
    mode,
    stores,
    carTakeAwayPlateNumber,
    carTakeAwayComments
  ) {
    if (
      (mode === "take-away" || mode === "car-take-away") &&
      this.groupApp &&
      this.groupApp.images_select_store_mobileorder
    ) {
      this.settingsModal = await this.modalCtrl.create({
        component: SelectStoreImagePopupComponent,
        cssClass: "selectStoreImagePopup",
        backdropDismiss: true,
        componentProps: {
          settingsPopupMode: true,
        },
      });
      await this.settingsModal.present();
      this.settingsModal.onDidDismiss().then(() => {
        this.settingsModal = null;
      });
    } else {
      let cssClass = "orderNowSettingsPopup";
      if (mode === "take-away" || mode === "car-take-away") {
        if (stores && stores.length > 1 && stores.length <= 3) {
          cssClass = "orderNowSettingsPopupThreeStores";
        } else if (stores && stores.length > 3) {
          cssClass = "orderNowSettingsPopupMultipleStores";
        }
      }

      if (
        mode === "delivery" &&
        this.groupApp &&
        this.groupApp.fixedPointsAddressSystemActive
      ) {
        const confirmation = await this.fixedPointsAddressPrompt();

        if (confirmation && confirmation === "new-address") {
          this.openSettingsPopupModal(
            mode,
            cssClass,
            carTakeAwayPlateNumber,
            carTakeAwayComments
          );
        } else if (confirmation && confirmation === "fixed-points-selection") {
          this.settingsModal = await this.modalCtrl.create({
            component: SelectedFixedPointsAddressModalComponent,
            cssClass: "",
            backdropDismiss: false,
            componentProps: {},
          });
          await this.settingsModal.present();
          this.settingsModal.onDidDismiss().then(async (data) => {
            this.settingsModal = null;
            if (data && data.data) {
              //fixed address id here

              const authState: any = await this.getStateObject("auth");
              const deliveryMethodAddressState: any = await this.getStateObject(
                "deliveryMethodAddress"
              );

              if (
                deliveryMethodAddressState &&
                deliveryMethodAddressState.fixedPointsAddresses &&
                deliveryMethodAddressState.fixedPointsAddresses.length
              ) {
                const selectedFixedAddress = _.find(
                  _.cloneDeep(deliveryMethodAddressState.fixedPointsAddresses),
                  { fixed_address_id: data.data }
                );
                if (selectedFixedAddress && selectedFixedAddress.address) {
                  const address = _.cloneDeep(selectedFixedAddress.address);

                  address.fixed_address_id = data.data;
                  address.fixed_address_name = _.cloneDeep(
                    selectedFixedAddress.name
                  );
                  address.fixed_address_type = _.cloneDeep(
                    selectedFixedAddress.type
                  );
                  if (authState.user?.only_visitor && address) {
                    this.fixedAddressesService.selectAddress(address);
                  } else if (authState.user && authState.mo_token && address) {
                    let new_user = _.cloneDeep(authState.user);
                    if (!new_user.addresses) {
                      new_user.addresses = [];
                    }

                    if (
                      !_.find(new_user.addresses, {
                        address_id: address.address_id,
                      })
                    ) {
                      new_user.addresses.push(_.cloneDeep(address));
                    }

                    //await for response and then select the address
                    const response =
                      await this.fixedAddressesService.updateCustomerData(
                        { updatedData: _.cloneDeep(new_user) },
                        authState.mo_token
                      );

                    if (response === "success") {
                      this.fixedAddressesService.selectAddress(address);
                    } else {
                      this.presentErrorToast(
                        this.translateService.instant(
                          "errorMessages.something_went_wrong_try_again"
                        ),
                        "danger"
                      );
                    }
                  } else if (!authState.user && address) {
                    this.fixedAddressesService.selectAddress(address);
                  }
                }
              }
            }
          });
        }
      } else {
        this.openSettingsPopupModal(
          mode,
          cssClass,
          carTakeAwayPlateNumber,
          carTakeAwayComments
        );
      }
    }
  }

  private async openSettingsPopupModal(
    mode,
    cssClass,
    carTakeAwayPlateNumber,
    carTakeAwayComments
  ) {
    this.settingsModal = await this.modalCtrl.create({
      component: OrderNowSettingsPopupComponent,
      cssClass: cssClass,
      backdropDismiss: false,
      componentProps: {
        mode: mode,
        carTakeAwayPlateNumber: carTakeAwayPlateNumber,
        carTakeAwayComments: carTakeAwayComments,
      },
    });
    await this.settingsModal.present();
    this.settingsModal.onDidDismiss().then(() => {
      this.settingsModal = null;
    });
  }

  private getStateObject(object) {
    return new Promise((resolve) => {
      this.store
        .select(object)
        .pipe(first())
        .subscribe((state) => {
          resolve(_.cloneDeep(state));
        })
        .unsubscribe();
    });
  }

  private async maybeClaimDineInVisitorSession(
    storeInfo: any,
    navigationOnDeliveryMethodChange = false
  ): Promise<boolean> {
    if (!this.visitorSessionAssistService.isDineInStoreEligible(storeInfo)) {
      return false;
    }

    const authState: any = await this.getStateObject("auth");
    // Real (non-visitor) user: classic dine-in flow (table modal / connected_mobile).
    if (authState && authState.user && !authState.user.only_visitor) {
      return false;
    }

    // No user (fresh) OR an existing visitor switching INTO dine-in. Reconcile
    // swaps the session (release old slot + claim dine-in) or fresh-claims, so a
    // take-away visitor selecting dine-in no longer keeps visitor_mode=takeaway
    // (which desynced from the order type and silently blocked the final price).
    // reconcile also syncs currentStoreId to the claimed store on success.
    const reconciled =
      await this.visitorSessionAssistService.reconcileVisitorSessionForMode(
        storeInfo,
        "dinein"
      );
    if (!reconciled.dineInTable) {
      return false;
    }

    this.applyDineInDeliveryMethod(
      reconciled.dineInTable,
      navigationOnDeliveryMethodChange
    );
    return true;
  }

  private applyDineInDeliveryMethod(
    selectedTable: any = null,
    navigationOnDeliveryMethodChange = false
  ): void {
    this.store.dispatch(
      new DeliveryMethodAddressActions.setSelectedDineInTable(
        _.cloneDeep(selectedTable)
      )
    );
    this.store.dispatch(new DeliveryMethodAddressActions.setDineIn(true));
    this.store.dispatch(
      new DeliveryMethodAddressActions.setOrderPickup(false)
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setValidDeliveryAreas(null)
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(null)
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setCarTakewayComments(null)
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setCheckSelectedAddress(null)
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setSelectedAddress(null)
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setSelectedPreorderDate(null)
    );

    if (navigator.cookieEnabled) {
      const deliveryMethodAddressObj: any = {
        orderPickup: false,
        dineIn: true,
        selectedDineInTable: selectedTable ? _.cloneDeep(selectedTable) : null,
      };

      window.localStorage.setItem(
        "deliveryMethodAddress",
        JSON.stringify(deliveryMethodAddressObj)
      );
    }

    this.dineInValidationsService.setDineInOrderStartTimestamp();
    if (
      (this.router.url === "/homepage" ||
        this.router.url === "/ratings" ||
        this.router.url === "/orders" ||
        this.router.url === "/points") &&
      navigationOnDeliveryMethodChange
    ) {
      this.router.navigateByUrl("/catalog", {
        replaceUrl: true,
      });
    }
  }

  async fixedPointsAddressPrompt() {
    return new Promise(async (resolve) => {
      const modal = await this.modalCtrl.create({
        component: FixedPointsAddressConfirmationPopupComponent,
        cssClass: "fixedPointsAddressPrompt",
        backdropDismiss: false,
        componentProps: {},
      });
      await modal.present();

      await modal.onDidDismiss().then((data) => {
        if (data && data.data) {
          resolve(data.data);
        }
        resolve("");
      });
    });
  }

  closeSettingsModal() {
    if (this.settingsModal) {
      this.settingsModal.dismiss();
      this.settingsModal = null;
    }
  }

  async addNewAddress() {
    this.addNewAddressModal = await this.modalCtrl.create({
      component: NewAddressModalComponent,
      cssClass: "my-custom-class",
      backdropDismiss: false,
    });
    await this.addNewAddressModal.present();
    this.addNewAddressModal.onDidDismiss().then(() => {
      this.addNewAddressModal = null;
    });
  }

  closeNewAddressModal() {
    if (this.addNewAddressModal) {
      this.addNewAddressModal.dismiss();
      this.addNewAddressModal = null;
    }
  }

  async openSelectStoreModal(storesForSelection) {
    return new Promise(async (resolve, reject) => {
      let cssClass = "selectStorePopupCss";
      if (
        storesForSelection &&
        storesForSelection.length > 1 &&
        storesForSelection.length <= 3
      ) {
        cssClass = "selectStorePopupCssThreeStores";
      } else if (storesForSelection && storesForSelection.length > 3) {
        cssClass = "selectStorePopupCssMultipleStores";
      }
      const modal = await this.modalCtrl.create({
        component: SelectStorePopupComponent,
        componentProps: {
          storesForSelection: storesForSelection,
          forDineinSelection: true,
          onlyReturnSelectedStoreId: true,
        },
        cssClass: cssClass,
        backdropDismiss: false,
      });

      await modal.present();

      await modal.onDidDismiss().then((data) => {
        if (data && data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      });
    });
  }

  async presentFirebaseRecaptchaModal() {
    this.firebaseRecaptchaModal = await this.modalCtrl.create({
      component: FirebaseRecaptchaComponent,
      backdropDismiss: false,
      cssClass: "fireBaseRecaptchaModal",
    });
    await this.firebaseRecaptchaModal.present();

    this.firebaseRecaptchaModal
      .onDidDismiss()
      .then(() => {
        this.firebaseRecaptchaModal = null;
        this.store
          .select("firebaseRecaptcha")
          .pipe(first())
          .subscribe((state) => {
            if (state && state.token && state.token !== "no-token") {
              this.checkOpenAddNewAddress();
            } else {
            }
          })
          .unsubscribe();
      })
      .finally(() => {});
  }

  closeFirebaseRecaptchaModal() {
    if (this.firebaseRecaptchaModal) {
      this.firebaseRecaptchaModal.dismiss();
      this.firebaseRecaptchaModal = null;
    }
  }

  private isDeliverySelectionModal(topModal): boolean {
    const component = topModal?.component;
    const componentName =
      typeof component === "string" ? component : component?.name;
    const modalClasses = Array.from(topModal?.classList || []);

    if (
      _.includes(
        [
          OrderNowPopupComponent.name,
          OrderNowSettingsPopupComponent.name,
          SelectStorePopupComponent.name,
          SelectStoreImagePopupComponent.name,
          NewAddressModalComponent.name,
          SelectedFixedPointsAddressModalComponent.name,
          FixedPointsAddressConfirmationPopupComponent.name,
          FirebaseRecaptchaComponent.name,
          DineInModalComponent.name,
        ],
        componentName
      )
    ) {
      return true;
    }

    return !!_.find(modalClasses, (modalClass) => {
      return _.includes(
        [
          "orderNowPopupCss",
          "orderNowSettingsPopup",
          "orderNowSettingsPopupThreeStores",
          "orderNowSettingsPopupMultipleStores",
          "selectStorePopupCss",
          "selectStorePopupCssThreeStores",
          "selectStorePopupCssMultipleStores",
          "selectStoreImagePopup",
          "fixedPointsAddressPrompt",
          "fireBaseRecaptchaModal",
          "dineInModal",
        ],
        modalClass
      );
    });
  }

  public async waitForDeliverySelectionFlowToComplete(
    timeoutMs: number = 120000
  ): Promise<void> {
    const startedAt = Date.now();

    while (Date.now() - startedAt < timeoutMs) {
      const topModal: any = await this.modalCtrl.getTop().catch(() => null);
      if (!this.isDeliverySelectionModal(topModal)) {
        return;
      }

      await new Promise((resolve) => {
        setTimeout(resolve, 150);
      });
    }
  }

  async selectDeliveryMethod(
    mode,
    navigationOnDeliveryMethodChange,
    carTakeAwayPlateNumber,
    carTakeAwayComments
  ) {
    // Take Away/Dine-in can reconcile immediately against the current store.
    // Delivery must wait until address validation resolves the final store;
    // SelectedAddressService owns that claim and canonical address save.
    const reconcileStoreInfo: any = await new Promise((resolve) => {
      this.store
        .select(getStoreInfo)
        .pipe(first())
        .subscribe((info: any) => resolve(info || null))
        .unsubscribe();
    });
    const reconcileTargetMode: "takeaway" | "dinein" | "delivery" =
      mode === "dine-in"
        ? "dinein"
        : mode === "delivery"
        ? "delivery"
        : "takeaway";
    const reconciled =
      reconcileTargetMode === "delivery"
        ? { dineInTable: null }
        : await this.visitorSessionAssistService.reconcileVisitorSessionForMode(
            reconcileStoreInfo,
            reconcileTargetMode
          );

    if (mode === "delivery") {
      this.store.dispatch(
        new DeliveryMethodAddressActions.setOrderPickup(false)
      );
      this.store.dispatch(new DeliveryMethodAddressActions.setDineIn(false));
      this.store.dispatch(
        new DeliveryMethodAddressActions.setSelectedDineInTable(
          _.cloneDeep(null)
        )
      );

      this.analyticsService.dmAnalyticsMessage(
        "delivery_method",
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      );
      if (navigator.cookieEnabled) {
        let deliveryMethodAddressObj: any = localStorage.getItem(
          "deliveryMethodAddress"
        );
        if (deliveryMethodAddressObj) {
          deliveryMethodAddressObj = JSON.parse(deliveryMethodAddressObj);
          if (deliveryMethodAddressObj) {
            deliveryMethodAddressObj.orderPickup = false;
            deliveryMethodAddressObj.dineIn = false;
            deliveryMethodAddressObj.selectedDineInTable = null;
          } else {
            deliveryMethodAddressObj = {
              orderPickup: false,
              dineIn: false,
            };
          }
        } else {
          deliveryMethodAddressObj = {
            orderPickup: false,
            dineIn: false,
          };
        }

        window.localStorage.setItem(
          "deliveryMethodAddress",
          JSON.stringify(deliveryMethodAddressObj)
        );
      }
      if (
        (this.router.url === "/homepage" ||
          this.router.url === "/ratings" ||
          this.router.url === "/orders" ||
          this.router.url === "/points") &&
        navigationOnDeliveryMethodChange
      ) {
        this.router.navigateByUrl("/catalog", {
          replaceUrl: true,
        });
      }
    } else if (mode === "take-away" || mode === "car-take-away") {
      console.log("tryiing to change to take away");

      if (mode === "car-take-away") {
        this.store.dispatch(
          new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(
            carTakeAwayPlateNumber
          )
        );
        this.store.dispatch(
          new DeliveryMethodAddressActions.setCarTakewayComments(
            carTakeAwayComments
          )
        );
      } else {
        this.store.dispatch(
          new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(null)
        );
        this.store.dispatch(
          new DeliveryMethodAddressActions.setCarTakewayComments(null)
        );
      }

      this.store.dispatch(
        new DeliveryMethodAddressActions.setSelectedAddress(null)
      );
      this.store.dispatch(
        new DeliveryMethodAddressActions.setOrderPickup(true)
      );
      this.store.dispatch(new DeliveryMethodAddressActions.setDineIn(false));
      this.store.dispatch(
        new DeliveryMethodAddressActions.setSelectedDineInTable(
          _.cloneDeep(null)
        )
      );
      this.store.dispatch(
        new DeliveryMethodAddressActions.setValidDeliveryAreas(null)
      );

      this.analyticsService.dmAnalyticsMessage(
        "takeaway_method",
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      );

      if (navigator.cookieEnabled) {
        let deliveryMethodAddressObj: any = localStorage.getItem(
          "deliveryMethodAddress"
        );
        if (deliveryMethodAddressObj) {
          deliveryMethodAddressObj = JSON.parse(deliveryMethodAddressObj);
          if (deliveryMethodAddressObj) {
            deliveryMethodAddressObj.orderPickup = true;
            deliveryMethodAddressObj.dineIn = false;
            deliveryMethodAddressObj.selectedAddress = null;
            deliveryMethodAddressObj.selectedDineInTable = null;

            deliveryMethodAddressObj.carTakeAwayPlateNumber =
              carTakeAwayPlateNumber;

            deliveryMethodAddressObj.carTakeAwayComments = carTakeAwayComments;
          }
        } else {
          deliveryMethodAddressObj = {
            orderPickup: true,
            dineIn: false,
          };
        }

        window.localStorage.setItem(
          "deliveryMethodAddress",
          JSON.stringify(deliveryMethodAddressObj)
        );
      }
      if (
        (this.router.url === "/homepage" ||
          this.router.url === "/ratings" ||
          this.router.url === "/orders" ||
          this.router.url === "/points") &&
        navigationOnDeliveryMethodChange
      ) {
        this.router.navigateByUrl("/catalog", {
          replaceUrl: true,
        });
      }
    } else if (mode === "dine-in") {
      // Visitor (re)claim already handled by reconcileVisitorSessionForMode
      // above; pin the claimed single table (or null for non-visitor flows).
      this.applyDineInDeliveryMethod(
        reconciled.dineInTable,
        navigationOnDeliveryMethodChange
      );

      this.analyticsService.dmAnalyticsMessage(
        "dinein_method",
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      );
    }
  }

  getGroupApp() {
    return new Promise((resolve) => {
      this.store
        .select("groupApp")
        .pipe(first())
        .subscribe((groupState) => {
          if (groupState && groupState.groupApp) {
            resolve(groupState.groupApp);
          } else {
            resolve({});
          }
        })
        .unsubscribe();
    });
  }

  getDeviceId() {
    return new Promise((resolve) => {
      this.store
        .select("platformInfo")
        .pipe(first())
        .subscribe((state) => {
          resolve(state.device_id || null);
        });
    });
  }

  async fetchDineInTables(store_id) {
    return new Promise(async (resolve) => {
      const device_id = await this.getDeviceId();

      this.dataStorageService
        .getDineInTables(this.groupApp.group, store_id, device_id)
        .subscribe({
          next: async (res: any) => {
            if (!res || !res.success) {
              resolve("error");
              const alert = await this.alertController.create({
                header: this.translateService.instant("alert"),
                message:
                  res && res.comment_id
                    ? this.translateService.instant(res.comment_id)
                    : this.translateService.instant(
                        "errorMessages.general_error"
                      ),
                backdropDismiss: false,
                buttons: ["OK"],
              });

              await alert.present();
            } else {
              resolve(res);
            }
          },
          error: async (error) => {
            resolve("error");
            const alert = await this.alertController.create({
              header: this.translateService.instant("alert"),
              message: this.translateService.instant(
                "errorMessages.problem_reaching_server"
              ),

              buttons: ["OK"],
            });
            await alert.present();
            return error;
          },
        });
    });
  }

  async modalWhenQrScannerNotAvailable(
    onlyAppsDineIn,
    otherAndroidUrl,
    otherIosUrl,
    selectedStore,
    webOnlyDineIn = false
  ) {
    const noQrScannerModal = await this.modalCtrl.create({
      component: NoScannerAvailableModalComponent,
      showBackdrop: true,
      cssClass:
        window && window.innerWidth <= 420
          ? "infoMessagesModalMobile"
          : "infoMessagesModalBrowser",
      componentProps: {
        branchLink: this.groupApp.branch_link,
        group: this.groupApp.group,
        hideSecondMessage: !!onlyAppsDineIn,
        otherAndroidUrl: otherAndroidUrl,
        otherIosUrl: otherIosUrl,
        selectedStore: selectedStore,
        selectedLang: this.selectedLangugage,
        app_name: this.groupApp.app_name,
        forOnlyAppsDinein: !!onlyAppsDineIn,
        webOnlyDineIn: !!webOnlyDineIn,
        showDownloadNowButton:
          !!onlyAppsDineIn &&
          (this.platform.is("android") || this.platform.is("ios")),
      },
    });
    await noQrScannerModal.present();
  }

  private shouldShowWebOnlyDineInScannerModal(store) {
    return !!(
      store &&
      store.dinein &&
      store.dine_in_disable_table_selection &&
      store.only_visitors_app &&
      !store.onlyAppsDineIn
    );
  }

  async checkAndOpenSettingsModal(
    mode,
    currentUser,
    selectedAddress,
    stores,
    currentStore_id,
    navigationOnDeliveryMethodChanged,
    modalDismiss,
    skipStoreSelection
  ) {
    const groupApp: any = await this.getGroupApp();
    if (mode === "car-take-away") {
      const alert = await this.alertController.create({
        header: this.translateService.instant("car_pickup_details"),
        inputs: [
          {
            name: "carPlate",
            type: "text",
            value: this.carTakeAwayPlateNumber || null,
            placeholder: this.translateService.instant("car_plate_number"),
          },
          {
            name: "comments",
            type: "textarea",
            value: this.carTakeAwayComments || null,
            placeholder: this.translateService.instant("comments"),
          },
        ],
        buttons: [
          {
            text: this.translateService.instant("cancel"),
            role: "cancel",
          },
          {
            text: this.translateService.instant("continue"),
            handler: (data) => {
              if (!data.carPlate || data.carPlate.trim().length < 4) {
                this.presentErrorToast(
                  this.translateService.instant("fill_valid_plate_number"),
                  "danger"
                );
                return false; // prevent dismissing if car plate is empty
              }
              // Continue logic here without calling other functions

              return this.pickupOrder(
                mode,
                stores,
                currentStore_id,
                navigationOnDeliveryMethodChanged,
                modalDismiss,
                data.carPlate,
                data.comments || null
              );
            },
          },
        ],
      });

      await alert.present();
    } else if (mode === "take-away") {
      return this.pickupOrder(
        mode,
        stores,
        currentStore_id,
        navigationOnDeliveryMethodChanged,
        modalDismiss,
        null,
        null
      );
    } else if (mode === "delivery") {
      this.analyticsService.dmAnalyticsMessage(
        "selected_delivery_method",
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      );

      if (
        (currentUser &&
          currentUser.addresses &&
          currentUser.addresses.length) ||
        (groupApp && groupApp.vatBasedCustomerAddressesActive)
      ) {
        console.log("present settings modal");
        this.presentSettingsModal(mode, stores, null, null);
        if (modalDismiss) {
          this.modalCtrl.dismiss();
        }
      } else {
        console.log("present add new address modal");
        if (!selectedAddress && !currentUser) {
          if (!Capacitor.isNativePlatform()) {
            this.store
              .select("firebaseRecaptcha")
              .pipe(first())
              .subscribe((state) => {
                if (state && state.token && state.token !== "no-token") {
                  this.checkOpenAddNewAddress();
                } else {
                  this.presentFirebaseRecaptchaModal();
                }
              })
              .unsubscribe();
          } else if (Capacitor.isNativePlatform()) {
            this.checkOpenAddNewAddress();
          }
        } else {
          this.checkOpenAddNewAddress();
        }
        if (modalDismiss) {
          this.modalCtrl.dismiss();
        }
      }
    } else if (mode === "dine-in") {
      let effectiveStore = _.find(stores, { store_id: currentStore_id });

      const thereIsStoreOnlyAppsDineIn = _.find(stores, {
        onlyAppsDineIn: true,
      });

      if (thereIsStoreOnlyAppsDineIn || stores?.length > 1) {
        const storesForSelection = _.cloneDeep(stores);

        _.each(storesForSelection, (store) => {
          if (store && store.dinein) {
            store.hasTheOffer = true;
          }
        });

        let selected_store_id;

        if (!skipStoreSelection) {
          selected_store_id = await this.openSelectStoreModal(
            _.cloneDeep(storesForSelection)
          );
        } else {
          selected_store_id = currentStore_id;
        }

        this.selectedStore = _.find(stores, {
          store_id: selected_store_id,
        });
        effectiveStore = this.selectedStore;

        if (this.selectedStore?.onlyAppsDineIn) {
          if (
            this.selectedStore?.onlyAppsDineIn &&
            !Capacitor.isNativePlatform()
          ) {
            const response: any = await this.fetchDineInTables(
              this.selectedStore.store_id
            );

            if (response && response.tables) {
              let otherAndroidUrl;
              let otherIosUrl;
              let uniqTable;
              if (response.tables) {
                let counter = 0;
                _.each(response.tables, (table) => {
                  if (table.active) {
                    uniqTable = table;
                    counter++;
                  }
                });

                if (counter === 1 && uniqTable) {
                  otherAndroidUrl =
                    this.selectedStore.group +
                    ".openapp.link/dinein-appdownload-" +
                    uniqTable.table_id;
                  otherIosUrl =
                    this.selectedStore.group +
                    ".openapp.link/dinein-appdownload-" +
                    uniqTable.table_id;
                }
              }

              this.modalWhenQrScannerNotAvailable(
                true,
                otherAndroidUrl,
                otherIosUrl,
                this.selectedStore
              );
            }
            return false;
          }
        }

        if (!this.selectedStore) {
          return;
        }
      }

      if (
        await this.maybeClaimDineInVisitorSession(
          effectiveStore,
          navigationOnDeliveryMethodChanged
        )
      ) {
        if (modalDismiss) {
          this.modalCtrl.dismiss();
        }
        return;
      }

      if (
        mode === "dine-in" &&
        effectiveStore &&
        effectiveStore.dine_in_disable_table_selection
      ) {
        if (Capacitor.isNativePlatform()) {
          const appInfo = await App.getInfo();
          console.log("app Info", appInfo);
          const targetVersion = "704000";
          const targetVersionIos = "7.4.0";
          const cleanVersion = (version: string) => version.replace(/\./g, "");
          const isGreaterOrEqual =
            parseInt(cleanVersion(appInfo.version)) >=
            parseInt(cleanVersion(targetVersionIos));
          if (
            (this.platform.is("android") &&
              parseInt(appInfo.build) >= parseInt(targetVersion)) ||
            (this.platform.is("ios") && isGreaterOrEqual)
          ) {
            this.openQrScannerSingleScan();
          } else {
            this.showToastForScanQr();
          }
        } else {
          this.modalWhenQrScannerNotAvailableDefault(
            this.shouldShowWebOnlyDineInScannerModal(effectiveStore)
          );
        }
      } else {
        this.openDineInModal(null, null);
        if (modalDismiss) {
          this.modalCtrl.dismiss();
        }
      }
    } else if (mode === "delivery-info-modal") {
      this.openDeliveryInfoModal();
    }
  }

  async openQrScannerSingleScan() {
    this.qrScanModal = await this.modalCtrl.create({
      component: QrScanModalComponent,
      cssClass: "barcode-scanning-modal",
      showBackdrop: false,
    });
    await this.qrScanModal.present();
  }

  async modalWhenQrScannerNotAvailableDefault(webOnlyDineIn = false) {
    this.noQrScannerModal = await this.modalCtrl.create({
      component: NoScannerAvailableModalComponent,
      showBackdrop: true,
      cssClass:
        window && window.innerWidth <= 420
          ? "infoMessagesModalMobile"
          : "infoMessagesModalBrowser",
      componentProps: {
        branchLink: this.groupApp.branch_link,
        group: this.groupApp.group,
        webOnlyDineIn: !!webOnlyDineIn,
      },
    });
    await this.noQrScannerModal.present();
  }

  async showToastForScanQr() {
    const alert = await this.alertController.create({
      header: this.translateService.instant("alert"),
      message: this.dineinTableLabelService.instant("open_camera_and_scan_table_qr"),
      backdropDismiss: true,
      buttons: ["OK"],
    });
    await alert.present();
    await alert.onDidDismiss().then(() => {
      //this.modalCtrl.dismiss();
    });
  }

  checkOpenAddNewAddress() {
    this.store
      .select("groupApp")
      .pipe(first())
      .subscribe(async (state) => {
        if (
          state &&
          state.groupApp &&
          state.groupApp.fixedPointsAddressSystemActive
        ) {
          const confirmation = await this.fixedPointsAddressPrompt();

          if (confirmation && confirmation === "new-address") {
            this.addNewAddress();
          } else if (
            confirmation &&
            confirmation === "fixed-points-selection"
          ) {
            this.settingsModal = await this.modalCtrl.create({
              component: SelectedFixedPointsAddressModalComponent,
              cssClass: "",
              backdropDismiss: false,
              componentProps: {},
            });
            await this.settingsModal.present();
            this.settingsModal.onDidDismiss().then(async (data) => {
              this.settingsModal = null;
              if (data && data.data) {
                //fixed address id here

                const authState: any = await this.getStateObject("auth");
                const deliveryMethodAddressState: any =
                  await this.getStateObject("deliveryMethodAddress");

                if (
                  deliveryMethodAddressState &&
                  deliveryMethodAddressState.fixedPointsAddresses &&
                  deliveryMethodAddressState.fixedPointsAddresses.length
                ) {
                  const selectedFixedAddress = _.find(
                    _.cloneDeep(
                      deliveryMethodAddressState.fixedPointsAddresses
                    ),
                    { fixed_address_id: data.data }
                  );
                  if (selectedFixedAddress && selectedFixedAddress.address) {
                    const address = _.cloneDeep(selectedFixedAddress.address);

                    address.fixed_address_id = data.data;
                    address.fixed_address_name = _.cloneDeep(
                      selectedFixedAddress.name
                    );
                    address.fixed_address_type = _.cloneDeep(
                      selectedFixedAddress.type
                    );

                    if (authState.user?.only_visitor && address) {
                      this.fixedAddressesService.selectAddress(address);
                    } else if (authState.user && authState.mo_token && address) {
                      let new_user = _.cloneDeep(authState.user);
                      if (!new_user.addresses) {
                        new_user.addresses = [];
                      }

                      if (
                        !_.find(new_user.addresses, {
                          address_id: address.address_id,
                        })
                      ) {
                        new_user.addresses.push(_.cloneDeep(address));
                      }

                      //await for response and then select the address
                      const response =
                        await this.fixedAddressesService.updateCustomerData(
                          { updatedData: _.cloneDeep(new_user) },
                          authState.mo_token
                        );

                      if (response === "success") {
                        this.fixedAddressesService.selectAddress(address);
                      } else {
                        this.presentErrorToast(
                          this.translateService.instant(
                            "errorMessages.something_went_wrong_try_again"
                          ),
                          "danger"
                        );
                      }
                    } else if (!authState.user && address) {
                      this.fixedAddressesService.selectAddress(address);
                    }
                  }
                }
              }
            });
          }
        } else {
          this.addNewAddress();
        }
      });
  }

  pickupOrder(
    mode,
    stores,
    currentStoreId,
    navigationOnDeliveryMethodChanged,
    modalDismiss,
    carTakeAwayPlateNumber,
    carTakeAwayComments
  ) {
    if (stores.length > 1 || this.groupApp.pickupModal) {
      this.presentSettingsModal(
        mode,
        stores,
        carTakeAwayPlateNumber,
        carTakeAwayComments
      );
      if (modalDismiss) {
        this.modalCtrl.dismiss();
      }
    } else {
      this.store.dispatch(
        new CurrentStoreActions.SetCurrentStoreId(stores[0].store_id)
      );
      if (navigator.cookieEnabled) {
        window.localStorage.setItem("store_id", currentStoreId);
      }
      if (modalDismiss) {
        this.modalCtrl.dismiss();
      }
      this.selectDeliveryMethod(
        mode,
        navigationOnDeliveryMethodChanged,
        carTakeAwayPlateNumber,
        carTakeAwayComments
      );
    }
  }

  async openDineInModal(
    selectedTableId,
    selectedStoreId,
    dineInSourceFromLink = null,
    onDismiss = null
  ) {
    let selectedStoreFromParent = null;
    if (!selectedStoreId && this.selectedStore) {
      selectedStoreFromParent = this.selectedStore;
    }

    this.dineInModal = await this.modalCtrl.create({
      component: DineInModalComponent,
      cssClass: "dineInModal",
      backdropDismiss: false,
      componentProps: {
        selectedTableIdFromLink: selectedTableId,
        selectedStoreFromLink: selectedStoreId,
        selectedStoreFromParent: selectedStoreFromParent,
        dineInSourceFromLink: dineInSourceFromLink,
      },
    });
    await this.dineInModal.present();
    this.dineInModal.onDidDismiss().then((data) => {
      if (
        data?.data &&
        data.data.type === "dine_in_disable_table_selection_store" &&
        data.data.store_id
      ) {
        this.store
          .select("stores")
          .pipe(first())
          .subscribe((storesState) => {
            this.store
              .select("auth")
              .pipe(first())
              .subscribe((state) => {
                if (state) {
                  this.selectedStore = data.data.store_id;
                  this.checkAndOpenSettingsModal(
                    "dine-in",
                    _.cloneDeep(state.user),
                    null,
                    storesState.stores,
                    data.data.store_id,
                    true,
                    true,
                    true
                  );
                }
              })
              .unsubscribe();
          })
          .unsubscribe();
      }
      this.dineInModal = null;
      if (_.isFunction(onDismiss)) {
        onDismiss(data);
      }
    });
  }

  closeDineInModal() {
    if (this.dineInModal) {
      this.dineInModal.dismiss();
      this.dineInModal = null;
    }
  }

  async presentErrorToast(message, color) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: "middle",

      color: color,
      buttons: [
        {
          side: "end",
          icon: "assets/ionicons/close.svg",

          handler: () => {
            console.log("Toast Closed");
          },
        },
      ],
    });
    toast.present();
  }

  // checkTheCatalog() {
  //   if (stores.length > 1) {
  //     this.presentSelectStoreModal();
  //   } else {
  //     this.store.dispatch(
  //       new CurrentStoreActions.SetCurrentStoreId(stores[0].store_id)
  //     );
  //     if (navigator.cookieEnabled) {
  //       window.localStorage.setItem("store_id", this.currentStoreId);
  //     }

  //     this.router.navigate(["catalog"]);
  //   }
  // }

  // async presentSelectStoreModal() {
  //   const modal = await this.modalCtrl.create({
  //     component: SelectStorePopupComponent,
  //     cssClass: "selectStoreInPaymentCardsPopup",
  //     backdropDismiss: false,
  //     componentProps: {},
  //   });

  //   await modal.present();
  //   modal.onDidDismiss().then((data) => {});
  // }

  checkToShowInfoDeliveryButton() {
    return new Promise((resolve) => {
      this.store
        .select("groupApp")
        .pipe(first())
        .subscribe((groupState) => {
          const groupApp = groupState.groupApp;

          if (
            groupApp &&
            groupApp.design_settings &&
            groupApp.design_settings.infoShowDeliveryButton
          ) {
            resolve(true);
          }

          resolve(false);
        })
        .unsubscribe();
    });
  }

  async openDeliveryInfoModal() {
    await this.modalCtrl.dismiss();

    this.deliveryInfoModal = await this.modalCtrl.create({
      component: DeliveryInfoModalComponent,
      cssClass: "delivery-info-modal",
      animated: true,
      componentProps: {
        message:
          this.groupApp &&
          this.groupApp.design_settings &&
          this.groupApp.design_settings.disableDeliveryInfo
            ? this.groupApp.design_settings.disableDeliveryInfo.message
            : null,
        button_one:
          this.groupApp &&
          this.groupApp.design_settings &&
          this.groupApp.design_settings.disableDeliveryInfo
            ? this.groupApp.design_settings.disableDeliveryInfo.button_one
            : null,
        button_two:
          this.groupApp &&
          this.groupApp.design_settings &&
          this.groupApp.design_settings.disableDeliveryInfo
            ? this.groupApp.design_settings.disableDeliveryInfo.button_two
            : null,
        button_three:
          this.groupApp &&
          this.groupApp.design_settings &&
          this.groupApp.design_settings.disableDeliveryInfo
            ? this.groupApp.design_settings.disableDeliveryInfo.button_three
            : null,
        selectedLanguage: this.selectedLangugage,
        baseLanguage: this.baseLanguage,
      },
      backdropDismiss: false,
    });

    await this.deliveryInfoModal.present();
    this.deliveryInfoModal.onDidDismiss().then(async (data) => {
      this.deliveryInfoModal = null;
    });
  }

  selectStore(storeID, modalDismiss) {
    if (storeID) {
      console.log("set store id order now modal");
      this.store.dispatch(new CurrentStoreActions.SetCurrentStoreId(storeID));
    }

    if (modalDismiss) {
      this.modalCtrl.dismiss();
    }
    this.router.navigateByUrl("/catalog", {
      replaceUrl: true,
    });
  }
}
